import { useState } from 'react'
import { db } from '../../services/db'
import type { UserType } from '../../utils/types'

export const useUser = () => {
  const [loadingCreate, setLoadingCreate] = useState(false)

  const registerUser = async (data: UserType) => {
    await db.user.clear()
    setLoadingCreate(true)

    db.user.add(data).finally(() => setLoadingCreate(false))
  }

  const getUser = async () => {
    const user = await db.user.toArray()

    return user.length ? user[0] : null
  }

  return {
    register: registerUser,
    isLoading: loadingCreate,
    getData: getUser,
  }
}
